import { IAIImageModel } from 'store/types/aiImage'
import { translate } from 'utils/translations'
import { replaceTranslationVariables } from 'utils/text-transformation'
import { T } from 'consts/translationKeys'
import { AI_IMAGE_MODEL_GROUP_MATCHERS } from './consts'

export const getImageGroupKey = (model: IAIImageModel): string => {
  const match = Object.entries(AI_IMAGE_MODEL_GROUP_MATCHERS).find(
    ([, regex]) => regex.test(model.name)
  )
  return match ? match[0] : model.code
}

export const getImageCapabilityLabels = (models: IAIImageModel[]): string[] => {
  const maxRefImages = models.reduce(
    (max, m) => Math.max(max, m.referenceImagesCount ?? 0),
    0
  )

  if (maxRefImages <= 0) return []

  return [
    replaceTranslationVariables(translate(T.UP_TO_LABEL), [
      `${maxRefImages} ${translate(
        maxRefImages > 1 ? T.REF_IMAGES_LABEL : T.REF_IMAGE_LABEL
      )}`
    ])
  ]
}
